import { defineMessages } from 'react-intl'

import { AppError } from '@app/errors/AppError'

import { createSelector } from '@app/utils/createSelector'
import { isValidEmail } from '@app/utils/isValidEmail'

import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

export type AcademyLoginForm = { email: string }

const academyLoginFormSlice = createReduxSlice<AcademyLoginForm>('academy_login_form')

export const setAcademyLoginFormEmail = (email: string) => academyLoginFormSlice.set({ email })

export const loginFormSelector = createSelector([academyLoginFormSlice.selector], form => form ?? EMPTY_LOGIN_FORM)

export function submitLoginForm() {
  return createThunk(async (dispatch, getState) => {
    const [{ postEmailTokens }, { callV2Api }, { getIntl }] = await Promise.all([
      import('@app/packages/api/v2/actions/email_tokens'),
      import('@app/store/actions/api'),
      import('@app/store/actions/initial'),
    ])
    const email = loginFormSelector(getState()).email
    const intl = dispatch(getIntl())
    if (!isValidEmail(email))
      throw new AppError('Invalid email').withLocalizedMessage(intl.formatMessage(messages.invalid_email)).withExpose(true).withHandled(true)
    return await dispatch(callV2Api(postEmailTokens(email, 'academy')))
  })
}

const EMPTY_LOGIN_FORM: AcademyLoginForm = { email: '' }

const messages = defineMessages({
  invalid_email: { id: "store.slices.academy.login_form.messages.invalid_email.91e2", defaultMessage: 'Неправильный Email' },
})
